
import EntryEditor from './EntryEditor.vue'
import AssetEditor from './AssetEditor.vue'

export default {
	name: 'StackingView',
	components: { EntryEditor, AssetEditor },
	props: {
		value: [ Object ],
		link: { type: Object }, // { id: string, type: 'Entry' | Asset }
		// 'path'  -> top entry lives in the route path (:id), used by the standalone ContentEdit view
		// 'query' -> top entry lives in the `entry` query param, used by the split view where the
		//            list descriptor (filter) already occupies the query on the same route
		urlMode: { type: String, default: 'path' },
	},
	data: () => ({
		editorStack: [],
	}),
	methods: {
		entrySelected(entries) {
			this.editorPush(entries[0])
		},
		// we want to be able to navigate back and forth honoring the editor stack
		// this is done by modifying the url to reflect the current stack:
		// .../entries/CURRENTLY-VIEWED-ENTRY?stack=FIRST-ON-STACK,SECOND-ON-STACK
		// in this example the real stack would look like this:
		// FIRST-ON-STACK -> SECOND-ON-STACK -> CURRENTLY-VIEWED-ENTRY
		routerBeforeEach(to, from, next) {
			const requestedStack = to.query.stack?.split?.(',').filter(Boolean) ?? []
			const top = this.urlMode === 'query' ? to.query.entry : to.params.id
			if (top) requestedStack.push(top)
			this.restoreStack(requestedStack)
			next()
		},
		restoreStack(requestedStack: string[]) {

			// remove excess editors
			while (this.editorStack.length > requestedStack.length) {
				// TODO: do we have to call the callback?
				//       the purpose of these callbacks is to reload the parent when the child closes
				//       (see AssetsField + ReferencesField)
				//       maybe for this use case its not needed to call these..
				//       BUT: it is probably required to REGISTER them - but how?
				//            probably we'll have to find a different mechanism than the callbacks, maybe a bus.
				this.editorStack.pop()
			}

			for (let i = 0; i < requestedStack.length; i++) {
				if (this.editorStack[i]?.link?.id == requestedStack[i]) continue

				// on mismatch: remove all after
				while (this.editorStack.length > i) {
					this.editorStack.pop()
				}

				// add missing editor
				this.editorPush(
					{ id: requestedStack[i], type: 'Entry' },
					// TODO: we dont have callbacks here.. what are they needed for?
					//       see TODO above!
					undefined,
					// dont update url when restoring stack to avoid having duplicate history states
					false,
				)
			}
		},
		// modify url to reflect current editor stack
		updateUrl() {
			const stack = [...this.editorStack]
			const current = stack.pop()
			const below = stack.map(e => e.link.id)

			if (this.urlMode === 'query') {
				// keep the list descriptor (filter) and split flag intact; only touch entry+stack
				const query = { ...this.$route.query }
				query.entry = current.link.id
				if (below.length > 0) query.stack = below.join(',')
				else delete query.stack
				if (JSON.stringify(query) != JSON.stringify(this.$route.query)) {
					this.$router.push({ path: this.$route.path, query })
				}
				return
			}

			const path = this.$route.path.replace(/\/entries\/.*/, '/entries/') + current.link.id
			// preserve any existing query params, only overriding `stack`
			const query = { ...this.$route.query }
			if (below.length > 0) query.stack = below.join(',')
			else delete query.stack
			const target = { path, query }
			if (this.$router.resolve(target).href != this.$route.fullPath) {
				this.$router.push(target)
			}
		},
		editorPush(link, callback, updateUrl = true) {
			this.editorStack.push({
				level: this.editorStack.length,
				// support both sys objects and refs
				link: { id: link.id, type: link.linkType ?? link.type },
				callback,
				// TODO: check if schema could not be found -> error
				//schema: window['contentTypes'][entry.sys.contentType.sys.id],
			})
			if (updateUrl) {
				this.updateUrl(link)
			}
		},
		// TODO: here we would like to send a signal to all displays of this entry to reload themselves.
		//       something like a broadcast to all Entry instances
		editorPop(savedObject, updateUrl = true) {
			if (this.editorStack.length == 1) {
				this.$emit('close')
				return
			}
			const editor = this.editorStack.pop()
			if (updateUrl) {
				this.updateUrl()
			}
			if (editor.callback) {
				editor.callback(savedObject)
			}
		},
	},
	mounted() {
		//this.editorPush(this.link, (...args: any[]) => { console.log('SVCB', args) })
		const requestedStack = this.$route.query.stack?.split?.(',').filter(Boolean) ?? []
		const top = this.urlMode === 'query' ? this.$route.query.entry : this.link.id
		if (top) requestedStack.push(top)
		this.restoreStack(requestedStack)
	},
}
